import { render, staticRenderFns } from "./UpdateQualification.vue?vue&type=template&id=305f806a&"
import script from "./UpdateQualification.vue?vue&type=script&lang=js&"
export * from "./UpdateQualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports